import {LatLng} from 'use-places-autocomplete';

import {TPinMapSelectedLocation} from '../types';

// Extract specific address component from Google response
export const extractGoogleMapComponent = (components: google.maps.GeocoderAddressComponent[], type: string) => {
  const component = components?.find((c) => c.types.includes(type));
  return component ? component.long_name : '';
};

export const extractGoogleAddressComponents = (
  placeDetails: google.maps.places.PlaceResult | google.maps.GeocoderResult,
  placeTitle = ''
): TPinMapSelectedLocation | null => {
  const addressComponents = placeDetails?.address_components;

  if (addressComponents) {
    const postalCode = extractGoogleMapComponent(addressComponents, 'postal_code');
    const province = extractGoogleMapComponent(addressComponents, 'administrative_area_level_1');
    let district = extractGoogleMapComponent(addressComponents, 'administrative_area_level_2');
    if (!district) {
      district = extractGoogleMapComponent(addressComponents, 'sublocality_level_1');
    }
    const subdistrict = extractGoogleMapComponent(addressComponents, 'sublocality');
    const coordinates = placeDetails.geometry?.location?.toJSON() as LatLng;

    const excludeTypes = [
      'postal_code',
      'administrative_area_level_1',
      'administrative_area_level_2',
      'sublocality',
      'country'
    ];

    const address = addressComponents
      .filter((component) => !component.types.some((type) => excludeTypes.includes(type)))
      .map((component) => component.long_name)
      .join(', ');

    return {
      postalCode,
      province,
      district,
      subdistrict,
      coordinates,
      address: placeTitle ? `${placeTitle}, ${address}` : address
    };
  }
  return null;
};
